document.addEventListener('DOMContentLoaded', function() {
  // Use event delegation to handle dynamically added elements
  document.body.addEventListener('click', async function(event) {
    // Check if the clicked element is the 'add-missing-items' button
    if (event.target && event.target.id === 'add-missing-items') {
      let missingVariantsData = event.target.getAttribute('data-missing-variants');

      if (!missingVariantsData) {
        console.warn("No missing variants data found.");
        return;
      }

      let missingVariants;
      try {
        missingVariants = JSON.parse(missingVariantsData);
      } catch (error) {
        console.error("Invalid JSON in data-missing-variants:", error);
        return;
      }

      // Ensure valid Shopify API request format
      let productsToAdd = missingVariants
        .filter(variantId => variantId) // Ensure no empty values
        .map(variantId => ({ id: parseInt(variantId, 10), quantity: 1, properties: { "Terms": "Agreed" } }));

      if (productsToAdd.length === 0) {
        console.warn("No valid items to add.");
        return;
      }

      try {
        let response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: productsToAdd })
        });

        if (!response.ok) {
          let errorData = await response.json();
          throw new Error(errorData.description || "Failed to add items to cart.");
        }

        // Update cart dynamically
        window.PXUTheme.jsAjaxCart.updateView();

      } catch (error) {
        console.error("Error adding to cart:", error);
      }
    }
  });
});
